/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Collapse } from 'antd';
import React from 'react';

const { Panel } = Collapse;

type CustomCollapseProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  defaultActive?: boolean;
  className?: string;
  onChange?: () => void;
};

const StyledCollapse = css`
  border: none;

  .ant-collapse-item {
    border: none;

    .ant-collapse-header {
      background-color: #ebebeb;
      border-radius: 4px;
      border: none !important;
    }
  }

  .ant-collapse-header {
    font-weight: 600;
    font-size: 16px;
    background-color: #fff;
    padding: 12px 16px;
  }

  .ant-collapse-content {
    background-color: #fff;
  }
`;

export default function CustomCollapse({
  title,
  children,
  className,
  defaultActive = false,
  onChange,
}: CustomCollapseProps) {
  return (
    <Collapse
      css={StyledCollapse}
      className={className}
      activeKey={defaultActive ? ['1'] : []}
      onChange={onChange}
    >
      <Panel header={title} key="1">
        {children}
      </Panel>
    </Collapse>
  );
}
